import { useQuery } from "@tanstack/react-query";
import { dataHealthApi } from "#/api/dataHealthApi";

export const DATA_HEALTH_QUERY_KEY = "data-health";

/**
 * The Data Health report, shared by the page and the navigation badge so both
 * read one request. Cached for five minutes; the page refetches on open.
 */
export function useDataHealth(clientId?: number, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [DATA_HEALTH_QUERY_KEY, clientId ?? "own"],
    queryFn: async () => (await dataHealthApi.getReport(clientId)).data,
    staleTime: 5 * 60 * 1000,
    enabled: options.enabled ?? true,
  });
}
